import { computed, observable, set } from 'mobx';
import { formatDateValue } from '~utils/FormatterUtils';
import { IBirthDate } from '~exported/loyalty-birthday/ILoyaltyBirthday';
import { ILoyaltyApiResponse } from '~api/interfaces/ILoyaltyApiResponse';

class LoyaltyInfo {
    @observable public currentPoints: number = 0;
    @observable public availablePoints: number = 0;
    @observable public hasLoyalty: boolean = false;
    @observable public levelDescription: string = '';
    @observable public tier: string = '';
    @observable public levelValue: number = 1;
    @observable public nextLevelPoints: number = 0;
    @observable public nextLevelSpend: number = 0;
    @observable public birthDay: number = 0;
    @observable public birthMonth: number = 0;
    @observable public loyaltyEnrolledSource: string = '';
    @observable public anniversaryDate: string = '';
    @observable public emailAddress: string = '';
    @observable public firstName: string = '';
    @observable public lastName: string = '';
    @observable public fullName: string = '';
    @observable public currentTierName: string = '';
    @observable public nextTierName: string = '';
    @observable public spendBased: boolean = false;
    @observable public spendAmount: number = 0;
    static fromJSON(loyaltyApiResponse: ILoyaltyApiResponse): LoyaltyInfo {
        const loyaltyInfo = new LoyaltyInfo();
        const { user, configs } = loyaltyApiResponse;
        const { loyaltyConfigs } = configs;
        const { programVersion } = loyaltyConfigs.current;
        const { tracksSpend } = loyaltyConfigs.current;
        const {
            birthdayDay,
            birthdayMonth,
            emailAddress,
            loyaltyActiveFlag,
            loyalty,
            nextAnniversaryDate,
            lastSource,
            firstName,
            lastName,
            fullName
        } = user;
        const { points, spend, level, rbTierName: currentTierName } = loyalty.loyaltyLevelCurrent;
        const { currentAvailable, available } = points;
        const { needs, rbTierName: nextTierName } = loyalty.loyaltyLevelNext;
        const pointsMin = needs?.pointsMin;
        const spendMin = needs?.spendMin;
        const spendAmount = spend?.qualifying;
        const anniversaryDate = formatDateValue(nextAnniversaryDate as string);
        const modifiedData = {
            ...loyaltyApiResponse,
            availablePoints: available,
            currentPoints: currentAvailable,
            hasLoyalty: loyaltyActiveFlag,
            levelValue: level,
            nextLevelPoints: pointsMin,
            nextLevelSpend: spendMin,
            programId: programVersion,
            spendBased: tracksSpend,
            spendAmount: spendAmount,
            emailAddress,
            firstName: firstName,
            lastName: lastName,
            fullName: fullName,
            birthDay: birthdayDay,
            birthMonth: birthdayMonth,
            loyaltyEnrolledSource: lastSource,
            currentTierName,
            nextTierName,
            anniversaryDate
        };
        set(loyaltyInfo, modifiedData);

        return loyaltyInfo;
    }

    @computed public get loyaltyPoints(): number {
        return this.currentPoints;
    }

    @computed public get birthdayInfo(): IBirthDate {
        return {
            month: this.birthMonth,
            day: this.birthDay
        };
    }
}

export default LoyaltyInfo;
